interface VersionHudProps {
  showMenu: boolean;
}

export const VersionHud = ({ showMenu }: VersionHudProps) => {

  const beVersion = JSON.parse(localStorage.getItem("beVersion") as string);

  const lastUpdated = (beDate: any, feDate: any) => {
    const be = !!beDate ? new Date(beDate) : new Date('01-01-1970');
    const fe = !!feDate ? new Date(feDate) : new Date("01-01-1970");

    return be > fe ? be.toDateString() : fe.toDateString();
  };

  return (
    <div
      className="nav-item w-100 d-flex justify-content-center"
      style={{ marginTop: "auto", marginBottom: "1.5rem" }}
    >
      {showMenu && (
        <ul
          className={`list-group text-center w-100 pb-1`}
          style={{ fontSize: "12px", listStyle: "none" }}
        >
          <li>Version Front-end: {`${process.env.REACT_APP_VERSION}`}</li>
          {!!beVersion?.version && (
            <li>Version Back-end: {`${beVersion?.version}`}</li>
          )}
          <li>
            Last Update:
            {lastUpdated(
              beVersion?.lastUpdate,
              process.env.REACT_APP_LAST_UPDATE_DATE,
            ).toString()}
          </li>
        </ul>
      )}
    </div>
  );
};
